var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.loaderOverlay, absolute: true } },
        [
          _c(
            "v-row",
            { attrs: { justify: "center" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "64" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card",
        { staticClass: "w-100 page-card", attrs: { outlined: "" } },
        [
          _c(
            "v-card-title",
            [
              _c("v-icon", { staticClass: "pr-2", attrs: { large: "" } }, [
                _vm._v("mdi-account-key"),
              ]),
              _c("h3", [_vm._v(_vm._s(_vm.$t("userRights")))]),
              _c("v-spacer"),
              !_vm.showLegend
                ? _c(
                    "v-row",
                    { attrs: { id: "overflowButtons", "no-gutters": "" } },
                    [
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "", color: "primary" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        {
                                          attrs: {
                                            id: "legendButton",
                                            color: "primary",
                                            fab: "",
                                            fixed: "",
                                            top: "",
                                            right: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.showLegend = true
                                            },
                                          },
                                        },
                                        on
                                      ),
                                      [
                                        _c(
                                          "v-icon",
                                          { staticStyle: { height: "unset" } },
                                          [_vm._v("mdi-table-of-contents")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1947775104
                          ),
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.$t("showLegend")))])]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "d-flex flex-wrap" },
                [
                  _c(
                    "v-text-field",
                    {
                      staticStyle: {
                        "border-radius": "2em / 5em",
                        "max-width": "600px",
                      },
                      attrs: {
                        label: _vm.$t("search"),
                        dense: "",
                        outlined: "",
                        "hide-details": "",
                      },
                      model: {
                        value: _vm.userListSearch,
                        callback: function ($$v) {
                          _vm.userListSearch = $$v
                        },
                        expression: "userListSearch",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "prepend" },
                        [
                          _vm.userListSearch == ""
                            ? _c("v-icon", [_vm._v("mdi-magnify")])
                            : _vm._e(),
                          _vm.userListSearch != ""
                            ? _c(
                                "v-icon",
                                {
                                  style: { cursor: "pointer" },
                                  attrs: { color: "primary " },
                                  on: {
                                    click: function ($event) {
                                      _vm.userListSearch = ""
                                    },
                                  },
                                },
                                [_vm._v("mdi-cached")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c("v-select", {
                    staticClass: "pl-8",
                    staticStyle: { "max-width": "300px" },
                    attrs: {
                      items: _vm.teams,
                      label: "Teams",
                      "hide-details": "",
                      multiple: "",
                    },
                    model: {
                      value: _vm.selectedTeams,
                      callback: function ($$v) {
                        _vm.selectedTeams = $$v
                      },
                      expression: "selectedTeams",
                    },
                  }),
                ],
                1
              ),
              _c("v-data-table", {
                staticClass: "elevation-1 table-header",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.filteredUserList,
                  "items-per-page": -1,
                  search: _vm.userListSearch,
                  "fixed-header": "",
                  "sort-by": "lastName",
                  height: "100%",
                  "hide-default-footer": "",
                  "item-key": "id",
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.lastName",
                    fn: function ({ item }) {
                      return [
                        _c("v-row", { attrs: { justify: "center" } }, [
                          _vm._v(" " + _vm._s(item.name) + " "),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "item.rights.user",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.user,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "user", $$v)
                                },
                                expression: "item.rights.user",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.projectUser",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.projectUser,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "projectUser", $$v)
                                },
                                expression: "item.rights.projectUser",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.manualTimekeeping",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.manualTimekeeping,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "manualTimekeeping",
                                    $$v
                                  )
                                },
                                expression: "item.rights.manualTimekeeping",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.userManager",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.userManager,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "userManager", $$v)
                                },
                                expression: "item.rights.userManager",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.presentList",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.presentList,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "presentList", $$v)
                                },
                                expression: "item.rights.presentList",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.chefPresentList",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.chefPresentList,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "chefPresentList", $$v)
                                },
                                expression: "item.rights.chefPresentList",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.timeCorrection",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.timeCorrection,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "timeCorrection", $$v)
                                },
                                expression: "item.rights.timeCorrection",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.reviewWorkTime",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.reviewWorkTime,
                                callback: function ($$v) {
                                  _vm.$set(item.rights, "reviewWorkTime", $$v)
                                },
                                expression: "item.rights.reviewWorkTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.reviewWorkTimeTeam",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.reviewWorkTimeTeam,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "reviewWorkTimeTeam",
                                    $$v
                                  )
                                },
                                expression: "item.rights.reviewWorkTimeTeam",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.projectAndBreaksTimeCorrection",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value:
                                  item.rights.projectAndBreaksTimeCorrection,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "projectAndBreaksTimeCorrection",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.projectAndBreaksTimeCorrection",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canChangeBusinessTripTime",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.canChangeBusinessTripTime,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canChangeBusinessTripTime",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.canChangeBusinessTripTime",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canAccessManagement",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.canAccessManagement,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canAccessManagement",
                                    $$v
                                  )
                                },
                                expression: "item.rights.canAccessManagement",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canAccessAbsenceOverview",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.canAccessAbsenceOverview,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canAccessAbsenceOverview",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.canAccessAbsenceOverview",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canAccessAbsenceOverviewTeam",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.canAccessAbsenceOverviewTeam,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canAccessAbsenceOverviewTeam",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.canAccessAbsenceOverviewTeam",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canAccessGeneralReporting",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value: item.rights.canAccessGeneralReporting,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canAccessGeneralReporting",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.canAccessGeneralReporting",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.rights.canAccessGeneralReportingTeam",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "v-row",
                          { attrs: { justify: "center" } },
                          [
                            _c("v-checkbox", {
                              model: {
                                value:
                                  item.rights.canAccessGeneralReportingTeam,
                                callback: function ($$v) {
                                  _vm.$set(
                                    item.rights,
                                    "canAccessGeneralReportingTeam",
                                    $$v
                                  )
                                },
                                expression:
                                  "item.rights.canAccessGeneralReportingTeam",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "pa-2" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: { click: _vm.saveUserGroups },
                },
                [_vm._v(_vm._s(_vm.$t("save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showLegend
        ? _c("UserRightsLegend", {
            on: {
              close: function ($event) {
                _vm.showLegend = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }